<template>
  <div >
    <!-- 导航栏 -->
    <Header :title="$t(title)" :link="goBackLink"></Header>
    <div class="appContent">
      <div class="projector-info ">
      <div class="text-center" :class="{discontinued:selectedModelData.discontinued}">
        <van-image :src="pjImgUrl" fit="contain"></van-image>
      </div>
      <div class="projector-title" :class="{discontinued:selectedModelData.discontinued}">{{selectedModelData.name}}</div>
      <div class="projector-btn clearfix" v-if="comparisonPJModelList.length > 0">
        <van-button round plain @click="linkNearModel('nearModel')">{{$t('T_NEAR_MODELS')}}</van-button>
      </div>
      <div class="space"></div>
      <div class="projector-lens clearfix" v-if="selectedLensData.id">
        <div class="projector-lens-img"><img :src="lensImgUrl" /></div>
        <div class="projector-lens-info">
          <div class="projector-lens-title">{{selectedLensData.name}}</div>
          <div class="projector-lens-distance">{{$t('T_LENS_THROW_DISTANCE')}}({{unitLabel}})<span>{{selectedLensDistance}}</span></div>
        </div>
        <div class="projector-lens-btn" @click="linkLensList">
          <span >{{$t('T_LENSES')}}</span>
          <span class="projector-lens-arrow">＞</span>
        </div>
      </div>
      <div class="space"></div>
      <div class="projector-content">
        <van-tabs
          color='#003298'
          line-width="170"
          line-height="2px"
          title-active-color='#003298'
          title-inactive-color='#000' >
          <van-tab :title="$t('T_BASIC_SPEC')">
            <van-cell-group>
              <van-cell v-for="(value, name, index) in mainSpecInfo"  :key="index" :title="mainSpecTitle(name)" :value="name === 'T_THROW_RATIO'? throwRatioText : value"></van-cell>
            </van-cell-group>
          </van-tab>
          <van-tab :title="$t('T_INTERFACE')">
            <van-cell-group>
              <van-cell v-for="(value, name, index) in interfaceInfo" :key="index" :title="$t(name)" :value="value"></van-cell>
            </van-cell-group>
          </van-tab>
          <van-tab :title="$t('T_FUNCTION')">
            <van-cell-group>
              <van-cell v-for="(value, name, index) in functionInfo" :key="index" :title="$t(name)" :value="value ? $t('T_YES') : $t('T_NO') ">
              </van-cell>
            </van-cell-group>
          </van-tab>
        </van-tabs>
      </div>
      <div class="projector-view">
        <van-button type="info" @click="linkProjectorView('projectorView')">{{$t("T_VIEW")}}</van-button>
      </div>
      </div>
    </div>
    <div class="popup">
      <van-popup v-model="showLenses" position="right" :style="{ height: '100%', width: '100%'}" >
        <lensList @close="closeLensesAction"  />
      </van-popup>
      <van-popup v-model="showNearModel" position="right" :style="{ height: '100%', width: '100%'}" >
        <nearModel @close="closeNearModelAction" :nearModelList="comparisonPJModelList" @onModelChange="onModelChange"/>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
// import ProjectorSpec from '@/assets/data/projectorSpec.json'
import Header from '@/components/header'
import nearModel from '@/views/NearModel'
import lensList from '@/views/LensList'
export default {
  name: 'projectorInfo',

  data () {
    return {
      mainSpecInfo: this.bindMainInfo(),
      interfaceInfo: this.bindInterfaceInfo(),
      functionInfo: this.bindFunctionInfo(),
      selectedModel: this.$store.state.selectedModelData.name,
      comparisonPJModelList: [],
      selectedLensDistance: '',
      showNearModel: false,
      showLenses: false,
      goBackLink: '',
      title: 'T_PROJECTOR_INFORMATION',
      oldLensArr: ['ELPLU02', 'ELPLR04', 'ELPLW04', 'ELPLS04', 'ELPLM06', 'ELPLM07', 'ELPLL07'],
      base_url: process.env.BASE_URL
    }
  },
  methods: {
    ...mapMutations([
      'SET_PJIMGTYPE',
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'VLENSSHIFT',
      'HLENSSHIFT',
      'VHLENSSHIFT',
      'ASPECTRATIO',
      'SET_SCREENSIZECHECKED',
      'SET_GRAPH_SCRNW',
      'SET_GRAPH_SCRNH',
      'SET_SCREENSIZE',
      'SET_VANGLE', 'SET_HANGLE', 'SET_VANGLEFLAG', 'SET_HANGLEFLAG',
      'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA',
      'SEARCHMATCHINGMODELDATA', 'SEARCHSELECTEDMODELDATA', 'SEARCHMATCHINGLENSID', 'SEARCHSELECTEDLENSDATA',
      'BMMATCHINGMODELDATA', 'BMSELECTEDMODELDATA', 'BMMATCHINGLENSID', 'BMSELECTEDLENSDATA',
      'HTMMATCHINGMODELDATA', 'HTMSELECTEDMODELDATA', 'HTMSELECTEDLENSDATA', 'SET_VLENSSHIFT', 'SET_DASHFLAG', 'SET_TEMVLENSSHIFT'
    ]),
    linkLensList () {
      this.showLenses = true
      history.pushState(null, null, '#')
    },
    linkNearModel (router) {
      if (this.comparisonPJModelList === 0) {
        this.$toast.fail('No Near Model')
      } else {
        this.showNearModel = true
        history.pushState(null, null, '#')
      }
    },
    closeNearModelAction () {
      this.showNearModel = false
    },
    closeLensesAction () {
      this.showLenses = false
    },
    linkProjectorView (router) {
      this.$router.push({ path: '/' + router })
    },
    // 投影仪切换
    onModelChange (value) {
      let changeFlg = this.$store.state.selectedModelData.name !== value.name || this.$store.state.selectedModelData.code !== value.code
      this.setSelectedModelData(value)
      let lensData = this.findMatchingLensAndSelectedLensData(this.selectedModelData)
      // this.setSelectedLensData(lensData)
      this.setSpecificInfo(lensData)
      if (changeFlg) {
        this.resetAspectRatio(lensData.lcd.aspectRatio)
      }
    },

    setSelectedModelData (value) {
      let selectedModelData = value
      this.SELECTEDMODELDATA(selectedModelData)
      if (this.searchTabActiveName === 'Search') {
        this.SEARCHSELECTEDMODELDATA(selectedModelData)
      } else {
        if (this.cateRadio === 'bmRadio') {
          this.BMSELECTEDMODELDATA(selectedModelData)
        } else {
          this.HTMSELECTEDMODELDATA(selectedModelData)
        }
      }
    },
    setLensData (idArr, data) {
      this.SEARCHMATCHINGLENSID(idArr)
      this.SEARCHSELECTEDLENSDATA(data)
      this.MATCHINGLENSID(idArr)
      this.SELECTEDLENSDATA(data)
    },
    setSelectedLensData (value) {
      this.MATCHINGLENSID(value.matchingLensID)
      this.SELECTEDLENSDATA(value.selectedLensInfo)
      if (this.searchTabActiveName === 'Search') {
        this.SEARCHMATCHINGLENSID(value.matchingLensID)
        this.SEARCHSELECTEDLENSDATA(value.selectedLensInfo)
      } else {
        if (this.cateRadio === 'bmRadio') {
          this.BMMATCHINGLENSID(value.matchingLensID)
          this.BMSELECTEDLENSDATA(value.selectedLensInfo)
        } else {
          this.HTMSELECTEDLENSDATA(value.selectedLensInfo)
        }
      }
    },
    setSelectedLensDistance () {
      let lensDataAll = this.$commonJs.findLensDataByIdAndSize(this.selectedLensData.id, this.selectedModelData.lcdSize)
      let distInfo = lensDataAll.lcd.distInfo.find(item => item.ratio === lensDataAll.lcd.aspectRatio)
      let throwRange = { min: distInfo.throwRange.w.min, max: distInfo.throwRange.t.max ? distInfo.throwRange.t.max : distInfo.throwRange.w.max }
      let throwRangeToUnit = { min: this.$commonJs.changeUnitDraw(throwRange.min, this.currentUnit, false), max: this.$commonJs.changeUnitDraw(throwRange.max, this.currentUnit, false) }
      this.selectedLensDistance = throwRange ? throwRangeToUnit.min + '----' + throwRangeToUnit.max : null
    },
    mainSpecTitle (name) {
      if (name === 'POWER_CONSUMPTION_110') {
        return this.$t('T_INFO_POWER_CONSUMPTION') + ' (100-110V)'
      } else if (name === 'POWER_CONSUMPTION_220') {
        return this.$t('T_INFO_POWER_CONSUMPTION') + ' (200-240V)'
      } else {
        return this.$t(name)
      }
    },
    bindMainInfo () {
      let data = JSON.parse(
        JSON.stringify(this.$store.state.selectedModelData)
      )
      let mainSpecData
      mainSpecData = {
        'T_INFO_BRIGHTNESS': data['color'],
        'T_INFO_CONTRAST': data['contrast'],
        'T_INFO_RESOLUTION': data['resolution'],
        'T_INFO_LIGHT_TYPE': data['lightType'],
        'T_INFO_WEIGHT': data['weightIncludingLens'],
        'T_INFO_SIZE': data['maxDimension'],
        'T_INFO_POWER_SUPPLY': data['supplyVoltage'],
        'POWER_CONSUMPTION_110': data['consumption100'] + ' (Normal) / ' + data['consumption100_eco'] + ' (Eco)',
        'POWER_CONSUMPTION_220': data['consumption220'] + ' (Normal) / ' + data['consumption220_eco'] + ' (Eco)',
        'T_INFO_FAN_NOISE': data['fanNoise']
      }
      if (data.lensExchange === false) {
        mainSpecData['T_THROW_RATIO'] = this.$store.state.selectedLensData.throwRatio
      }
      return mainSpecData
    },
    bindInterfaceInfo () {
      let data = JSON.parse(
        JSON.stringify(this.$store.state.selectedModelData)
      )
      let interfaceData = {
        'T_INFO_RGB': data['inputRgb'],
        'T_INFO_HDMI': data['inputHdmi'],
        'T_INFO_VIDEO': data['inputVideo'],
        'T_INFO_USBA': data['inputUsbA'],
        'T_INFO_HDBASET': data['inputHdBaseT'],
        'T_INFO_WIRED_LAN': data['inputWiredLan'],
        'T_INFO_WIRELESS_LAN': data['inputWirelessLan']
      }
      return interfaceData
    },
    bindFunctionInfo () {
      let data = JSON.parse(
        JSON.stringify(this.$store.state.selectedModelData)
      )
      let functionData = {
        'T_INFO_PC_FREE': data['PCFREE'],
        'T_INFO_APP_FOR_PC': data['iProjectionForPC'],
        'T_INFO_APP_FOR_IOS': data['iProjectionForIOS'],
        'T_INFO_APP_FOR_ANDROID': data['iProjectionForAndroid']
      }
      return functionData
    },
    findMatchingLensAndSelectedLensData (model) {
      let lensInfo = this.$commonJs.findLensInfo(model)
      this.setLensData(lensInfo.matchingLensID, lensInfo.selectedLensInfo)
      if (model.lensExchange) {
        this.setSelectedLensDistance()
      }
      return lensInfo.selectedLensInfo
    },
    setSpecificInfo (data) {
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(defaultRatio, data)

      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)
      let vals = {}
      if (this.position === 0) {
        vals = data.lcd.lensShiftRange.v
        if (data.lcd.lensShiftRange.v.min > 0) {
          this.SET_VLENSSHIFT(data.lcd.lensShiftRange.v.min * 100)
        } else if (this.vLensShiftNow) {
          this.SET_VLENSSHIFT(0)
        }
      } else if (this.position === 1 || this.position === 2) {
        vals.max = data.lcd.lensShiftRange.v.min * -1
        vals.min = data.lcd.lensShiftRange.v.max * -1
        if (vals.max < 0) {
          this.SET_VLENSSHIFT(vals.max * 100)
        } else if (this.vLensShiftNow) {
          this.SET_VLENSSHIFT(0)
        }
      }

      if (data.lcd.lensShiftRange.h.min > 0) {
        this.SET_HLENSSHIFT(data.lcd.lensShiftRange.h.min * 100)
      } else if (this.hLensShiftNow) {
        this.SET_HLENSSHIFT(0)
      }

      if (this.vAngle) {
        this.SET_VANGLE(0)
      }
      if (this.hAngle) {
        this.SET_HANGLE(0)
      }
      this.SET_VANGLEFLAG(false)
      this.SET_HANGLEFLAG(false)
      this.SET_DASHFLAG(false)

      this.VLENSSHIFT(vals)
      this.SET_TEMVLENSSHIFT(vals)
      this.HLENSSHIFT(data.lcd.lensShiftRange.h)
      this.VHLENSSHIFT(data.lcd.lensShiftRange.hv)

      // 为超短焦设置默认vlens shift
      if (this.selectedModelData.type === 1 && data.lcd.lensShiftRange.v.min === 0 && data.lcd.lensShiftRange.v.max === 0) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let v1b = defaultDistInfo.screenSize.w.min * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        let res = (initSize.calY / 2 + v1b - data.mu) / initSize.calY
        let va = {}
        if (this.position === 1 || this.position === 2) {
          this.SET_VLENSSHIFT(res * 100 * -1)
        } else {
          this.SET_VLENSSHIFT(res * 100)
        }
        va.max = res
        va.min = res
        this.VLENSSHIFT(va)
        this.SET_TEMVLENSSHIFT(va)
      } else if (this.$commonViewJs.isLongLensExistsLens()) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let res = (defaultDistInfo.wv.wv2 * defaultDistInfo.screenSize.w.min - initSize.calY / 2) / initSize.calY
        // let res = (1.35799 * defaultDistInfo.screenSize.w.min - initSize.calY / 2) / initSize.calY
        this.SET_VLENSSHIFT(res * 100)
        let va = {}
        va.max = res
        va.min = res
        this.VLENSSHIFT(va)
        this.SET_TEMVLENSSHIFT(va)
      }

      // // 判断是否显示超短焦专用画面
      // if (this.selectedModelData.category === 4) {
      //   this.SET_ISUSTWALL(true)
      // } else {
      //   this.SET_ISUSTWALL(false)
      // }
    },
    // 重置宽高比
    resetAspectRatio (aspectRatio) {
      // 没有枷锁且投影仪没有变更的场合，当选择的镜头变更时，保持原来选择的宽高比(オプションレンズを変えると設定しているアスペクトが維持の対応)
      // 以外的场合，镜头默认的宽高比
      // console.log('resetAspectRatio data.lcd.aspectRatio:', aspectRatio)
      // console.log('resetAspectRatio this.aspectRatio:', this.aspectRatio)
      const hasAspectRatio = this.selectedLensData_lcd_distInfo.some(item => item.ratio === this.aspectRatio)
      // 本函数执行的场合，this.isUSTWall还没有根据选择的投影仪来变更值，所以先判断是否显示超短焦
      let isUSTWall = this.selectedModelData.category === 4 && this.position === 2
      if (!hasAspectRatio || !this.screenSizeChecked || this.isSimple || isUSTWall) {
        this.ASPECTRATIO(aspectRatio)
      }
      if (!hasAspectRatio && this.screenSizeChecked) {
        this.SET_SCREENSIZECHECKED(false)
      }
    },
    // 获取比较的机型
    findComparisonProjectorList () {
      this.comparisonPJModelList = []
      let lensData
      this.ProjectorSpec.map(pjItem => {
        if (pjItem.year * 1 >= 2016 && (this.isConfigured !== 1 || (this.isConfigured === 1 && pjItem.recommend))) {
          if (pjItem.lensExchange) {
            lensData = this.$commonJs.findLensDataByIdAndSize(pjItem.standardLens, pjItem.lcdSize)
          } else {
            lensData = this.$commonJs.findLensDataByHCode(pjItem.code)
          }
          if (!lensData) {
            console.log('findComparisonProjectorList error') // TODO
            return
          }

          let distInfoData = lensData.lcd.distInfo
          let lensShiftRange = lensData.lcd.lensShiftRange
          for (let i = 0; i < distInfoData.length; i++) {
            let _screenSize = distInfoData[i].screenSize
            let screenSizeRange = {
              min: _screenSize.w.min,
              max: _screenSize.t.max ? _screenSize.t.max : _screenSize.w.max
            }
            if (this.screenSize >= screenSizeRange.min && this.screenSize <= screenSizeRange.max) {
              let size2dist = distInfoData[i].size2dist
              let throwRange = this.getThrowDistanceRange(size2dist)
              if (this.graph.pjY >= Math.floor(throwRange.min) && this.graph.pjY <= throwRange.max) {
                let flag = 'Not Available'
                for (let key in lensShiftRange) {
                  if (lensShiftRange[key].max !== 0 || lensShiftRange[key].min !== 0) {
                    flag = 'Available'
                  }
                }
                this.comparisonPJModelList.push({
                  ...pjItem,
                  brightness: pjItem.whiteNormal,
                  resolution: pjItem.resolution,
                  lensShiftAvailable: flag
                })

                break
              }
            }
          }
        }
      })
    },
    // 改距离，影响宽,高,对角线
    changeDistance () {
      let result = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
      this.SET_GRAPH_SCRNW(result.calX)
      this.SET_GRAPH_SCRNH(result.calY)
      result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
      this.SET_SCREENSIZE(result)
    },
    getThrowDistanceRange (size2dist) {
      let size2distW = size2dist.w
      let size2distT = size2dist.t
      let screenSize = this.screenSize
      let throwDistanceMin = size2distW.a * screenSize + size2distW.b
      let throwDistanceMax = size2distT ? size2distT.a * screenSize + size2distT.b : size2distW.a * screenSize +
      size2distW.b
      let throwDistanceRange = {
        min: throwDistanceMin,
        max: throwDistanceMax
      }
      return throwDistanceRange
    },

    selectedModelAction () {
      if (!this.comparisonPJModelList || this.comparisonPJModelList.length < 1) {
        this.$message('No Near Model')
      } else {
        this.selectedModelDialogVisible = true
      }
    },
    onBrowserBack () {
      let hash = window.location.hash
      if (this.showLenses === false && this.showNearModel === false && hash === '#/projectorInfo') {
        if (this.searchTabActiveName === 'Search') {
          this.$router.push({ path: '/searchProjectors' })
        } else {
          this.$router.push({ path: '/categolies' })
        }
      }
      if (this.showLenses) {
        this.showLenses = false
      }
      if (this.showNearModel) {
        this.showNearModel = false
      }
    }
  },

  watch: {
    selectedModelData: {
      handler (val, oldVal) {
        this.selectedModel = val.name
        this.mainSpecInfo = this.bindMainInfo()
        this.interfaceInfo = this.bindInterfaceInfo()
        this.functionInfo = this.bindFunctionInfo()
        this.SET_PJIMGTYPE(this.selectedModelData.type)
        this.findComparisonProjectorList()
      },
      deep: true
    },
    screenSize () {
      this.findComparisonProjectorList()
    },
    f_d2sComputed (newValue, oldValue) {
      this.changeDistance()
    },
    selectedLensData (val) {
      if (val) {
        this.setSpecificInfo(val)
        // 选择的镜头 是否支持 原来选择的宽高比（true:支持, false:不支持）
        // 不支持的场合，设定为镜头默认的宽高比
        const hasAspectRatio = this.selectedLensData_lcd_distInfo.some(item => item.ratio === this.aspectRatio)
        if (!hasAspectRatio) {
          this.resetAspectRatio(val.lcd.aspectRatio)
        }
      }
      if (val.id) {
        this.setSelectedLensDistance()
      }
    },
    currentUnit (val) {
      this.setSelectedLensDistance()
    }
  },
  computed: {
    ...mapState([
      'screenSize',
      'graph',
      'searchTabActiveName',
      'selectedModelData',
      'selectedLensData',
      'matchingLensID',
      'aspectRatio',
      'cateRadio', 'graph',
      'vLensShiftNow',
      'hLensShiftNow',
      'vAngle',
      'hAngle',
      'position',
      'isConfigured',
      'screenSizeChecked',
      'isUSTWall',
      'isSimple'
    ]),
    ...mapGetters([
      'unitLabel',
      'selectedLensData_lcd_distInfo'
    ]),
    matchingModelData () {
      return this.$store.state.matchingModelData
    },

    // f_d2sComputed () {
    //   return this.graph.f_d2s
    // },
    white () {
      return this.selectedModelData.whiteNormal
    },
    color () {
      return this.selectedModelData.color
    },
    resolution () {
      return this.selectedModelData.resolution
    },
    weight () {
      return this.selectedModelData.weight.includingLens
    },
    lensImgUrl () {
      // return require('../' + this.selectedLensData.url + '.png')
      console.log(process.env.BASE_URL)
      let url = this.selectedLensData.url.replace('static/', './')
      return url + '.jpg'
    },
    pjImgUrl () {
      console.log(process.env.BASE_URL)
      let url = this.selectedModelData.url.replace('static/', './')
      return url + '.jpg'
    },
    currentUnit () {
      return this.graph.unit
    },
    throwRatioText () {
      const DigiZoom = this.$store.state.selectedModelData.DigiZoom
      if (DigiZoom === 'True') {
        return this.$store.state.selectedLensData.throwRatio + ' ' + this.$t('T_DIGITAL_ZOOM')
      } else {
        return this.$store.state.selectedLensData.throwRatio
      }
    }
  },
  created () {
    if (this.searchTabActiveName === 'Search') {
      this.goBackLink = 'searchProjectors'
    } else {
      this.goBackLink = 'categolies'
    }
    this.findComparisonProjectorList()
    let lensData = {}
    if (this.selectedLensData == null || this.selectedLensData.id === undefined) {
      lensData = this.findMatchingLensAndSelectedLensData(this.$store.state.selectedModelData)
    } else {
      this.setSelectedLensDistance()
      lensData = this.selectedLensData
    }
    this.setSpecificInfo(lensData)
    if (this.$route.params.modelChange) {
      this.resetAspectRatio(lensData.lcd.aspectRatio)
    }
    this.SET_PJIMGTYPE(this.selectedModelData.type)
    this.SET_DASHFLAG(false)
  },
  mounted () {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.onBrowserBack, false)
    }
  },
  destroyed () {
    if (window.history && window.history.pushState) {
      window.removeEventListener('popstate', this.onBrowserBack, false)
    }
  },
  components: {
    Header,
    nearModel,
    lensList
  }
}
</script>

<style scoped>

  .van-tabs--line .van-tabs__wrap{
    height: 25px;
  }
  .van-cell__value{
    text-align: left
  }
  .discontinued {
    background: #DCDFE6
  }
</style>
